import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import RadioFieldSet from 'components/ui/RadioFieldSet';
import { YES, NO } from '../YesNoQuestionnaire.constants';

const YesNoQuestion = ({ legend, name, selectedValue, onChange }) => (
  <RadioFieldSet
    noDefault
    name={name}
    legend={legend}
    radioButtons={[
      { value: YES, label: <FormattedMessage id={`interaction.${YES}`} /> },
      { value: NO, label: <FormattedMessage id={`interaction.${NO}`} /> }
    ]}
    selectedValue={selectedValue}
    onChange={onChange}
  />
);

YesNoQuestion.propTypes = {
  legend: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  selectedValue: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default YesNoQuestion;
